import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/a1/company'

const list = async (curPage, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

const del = async (seq, result) => {
  const options = {
    method: 'DELETE',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {
      seq: seq
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 400) {
        result(response.data.message)
      } else {
        result(null)
      }
    })
}

const get = async (seq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/' + seq,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const save = async (seq, form, result) => {
  const options = {
    method: 'PUT',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: form
  }
  if (seq) {
    options.method = 'PUT'
    await axios(options)
      .then((response) => {
        if (response.data.code === 300) {
          result(response.data.code, response.data.message)
        } else {
          result(null)
        }
      })
  } else {
    options.method = 'POST'
    await axios(options)
      .then((response) => {
        if (response.data.code === 200) {
          result(response.data.code, response.data.message)
        } else {
          result(null)
        }
      })
  }
}

const mCompanys = async (result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/mcompanys',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const sCompanys = async (company, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/scompanys',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    params: {
      name: company
    }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

export default {
  list,
  del,
  get,
  save,
  mCompanys,
  sCompanys
}
export {
  mCompanys,
  sCompanys
}
